import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress errors from browser extensions and webpack overlay for non-app errors
window.addEventListener('error', (event) => {
  if (event.filename && (event.filename.startsWith('chrome-extension://') || event.filename.startsWith('moz-extension://'))) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason?.stack || event.reason?.message || String(event.reason || '');
  if (reason.includes('chrome-extension://') || reason.includes('moz-extension://') || reason.includes('Origin not allowed')) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});

// Hide webpack error overlay for non-critical errors
if (typeof window !== 'undefined') {
  const origError = console.error;
  console.error = (...args) => {
    const msg = args.join(' ');
    if (msg.includes('chrome-extension://') || msg.includes('Origin not allowed')) return;
    origError.apply(console, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
